import React from 'react'

const Tag = ({ text, remove, disabled }) => {
  const handleOnRemove = (e) => {
    e.stopPropagation()
    remove(text)
  }

  return (
    <span className="inline-flex justify-center items-center w-fit relative py-0.5 px-3 mt-2.5 mr-2.5 rounded-sm border-gray-300 bg-[#f2f2f2]">
      <span className="font-medium pr-3">#{text}</span>
      {!disabled && (
        <div
          className="bg-white text-white cursor-pointer text-xs w-5 h-5 overflow-hidden rounded-full z-50"
          onClick={handleOnRemove}
        >
          <img src={'/assets/common/icon-cross.svg'} alt="close" className="w-full h-full object-cover" />
        </div>
      )}
    </span>
  )
}

export default Tag
